import { GMResolutionsPostRequest } from '@/dtos/resolutions/gm-resolution/post'

export class GMResolutionsDraftPostRequest extends GMResolutionsPostRequest {}
